import { BrowserRouter, Navigate, Route, Routes, useParams } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import { RequireAuth } from './auth/RequireAuth';
import { RequireRole } from './auth/RequireRole';
import { LandingPage } from './landing/LandingPage';
import { PrivacyPage } from './landing/PrivacyPage';
import { BoardPage } from './pages/BoardPage';
import { HomePage } from './pages/HomePage';
import { InvitePage } from './pages/InvitePage';
import { LoginPage } from './pages/LoginPage';
import { MyBoardsPage } from './pages/MyBoardsPage';
import { StudentCardPage } from './pages/StudentCardPage';
import { StudentFormPage } from './pages/StudentFormPage';
import { StudentsListPage } from './pages/StudentsListPage';

function RedirectWithParams({ to }: { to: string }) {
  const params = useParams();
  const keys = Object.keys(params);
  if (keys.length === 0) return <Navigate to={to} replace />;
  const suffix = keys.map((k) => params[k]).join('/');
  return <Navigate to={`${to}/${suffix}`} replace />;
}

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Landing */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />

          {/* App under /app */}
          <Route path="/app/login" element={<LoginPage />} />
          <Route path="/app/invite/:token" element={<InvitePage />} />

          <Route element={<RequireAuth />}>
            <Route element={<RequireRole allow={['TUTOR', 'STUDENT']} />}>
              <Route path="/app/boards/:id" element={<BoardPage />} />
            </Route>

            <Route element={<RequireRole allow={['TUTOR', 'ADMIN']} />}>
              <Route path="/app" element={<HomePage />} />
              <Route path="/app/students" element={<StudentsListPage />} />
              <Route path="/app/students/new" element={<StudentFormPage />} />
              <Route path="/app/students/:id" element={<StudentCardPage />} />
              <Route path="/app/students/:id/edit" element={<StudentFormPage />} />
            </Route>

            <Route element={<RequireRole allow={['STUDENT']} />}>
              <Route path="/app/my" element={<MyBoardsPage />} />
            </Route>
          </Route>

          {/* 301-redirects со старых URL */}
          <Route path="/login" element={<Navigate to="/app/login" replace />} />
          <Route path="/invite/:token" element={<RedirectWithParams to="/app/invite" />} />
          <Route path="/students" element={<Navigate to="/app/students" replace />} />
          <Route path="/students/new" element={<Navigate to="/app/students/new" replace />} />
          <Route path="/students/:id" element={<RedirectWithParams to="/app/students" />} />
          <Route path="/boards/:id" element={<RedirectWithParams to="/app/boards" />} />
          <Route path="/my" element={<Navigate to="/app/my" replace />} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
